module.exports = __webpack_public_path__ + "static/media/systam-logo.d617c956.svg";